import { render, staticRenderFns } from "./Bulletins.vue?vue&type=template&id=0ca79820"
import script from "./Bulletins.vue?vue&type=script&lang=js"
export * from "./Bulletins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports